"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function binarySearch(sortedArray, key) {
  var start = 0;
  var end = sortedArray.length - 1;

  while (start <= end) {
    var middle = Math.floor((start + end) / 2);

    if (sortedArray[middle] === key) {
      // found the key
      return middle;
    }

    if (sortedArray[middle] < key) {
      // continue searching to the right
      start = middle + 1;
    } else {
      // search searching to the left
      end = middle - 1;
    }
  } // key wasn't found


  return -1;
} // eslint-disable-next-line no-unused-vars


function arrayMergeUnique(destinationArray, sourceArray, _options) {
  var result = destinationArray.slice();
  var index = destinationArray.map(function (i) {
    return JSON.stringify(i);
  }).sort();
  sourceArray.forEach(function (i) {
    if (binarySearch(index, JSON.stringify(i)) < 0) {
      result.push(i);
    }
  });
  return result;
}

var _default = arrayMergeUnique;
exports.default = _default;